import client from '../../shared/api/client';
import { P2pPaymentMethod, PaginatedResponse } from '../../shared/types';

interface PaymentMethodsBackendResponse {
  status: string;
  data: PaginatedResponse<P2pPaymentMethod>;
}

interface SinglePaymentMethodResponse {
  status: string;
  data: P2pPaymentMethod;
}

export interface PaymentMethodsFilters {
  page?: number;
  per_page?: number;
  search?: string;
}

export interface PaymentMethodInput {
  code?: string;
  name: string;
  fiat_currencies?: string[];
  sort_order?: number;
  is_active?: boolean;
}

export const listPaymentMethods = async (
  filters: PaymentMethodsFilters = {}
): Promise<PaginatedResponse<P2pPaymentMethod>> => {
  const params: Record<string, string | number | undefined> = {
    page: filters.page ?? 1,
    per_page: filters.per_page ?? 20,
  };
  if (filters.search) params.search = filters.search;
  const response = await client.get<PaymentMethodsBackendResponse>('/p2p/payment-methods', { params });
  return response.data.data;
};

export const createPaymentMethod = async (data: PaymentMethodInput): Promise<P2pPaymentMethod> => {
  const response = await client.post<SinglePaymentMethodResponse>('/p2p/payment-methods', data);
  return response.data.data;
};

export const updatePaymentMethod = async (
  id: number,
  data: Partial<PaymentMethodInput>
): Promise<P2pPaymentMethod> => {
  const response = await client.put<SinglePaymentMethodResponse>(`/p2p/payment-methods/${id}`, data);
  return response.data.data;
};

export const deletePaymentMethod = async (id: number): Promise<void> => {
  await client.delete(`/p2p/payment-methods/${id}`);
};
